import React, { FC } from "react";
import { TableCell, Typography } from "@mui/material";
import StatusTooltip from "./StatusTooltip";
import { calcWithAdminCharge } from "../../../../util/calcWithAdminCharge";
import { StyledCheckbox } from "./StyledCheckbox";
import { styled } from "@mui/material/styles";
import { TableCellsProps } from "../RoleTableCells";
import { QuoteObj } from "../../../../GlobalTypes";

interface DealerCellsProps extends TableCellsProps {
  role: string;
}

const StyledViewQuote = styled(Typography)({
  "&:hover": {
    cursor: "pointer",
  },
  textDecoration: "underline",
});

const StyledTableCell = styled(TableCell)({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: 200,
});

const DealerCells: FC<DealerCellsProps> = ({
  tab,
  row,
  handleViewClick,
  role,
  isItemSelected,
  handleCheck,
  numSelected,
  hoverId,
}) => {
  const dealerTax = JSON.parse(sessionStorage.getItem("dealerTax") || JSON.stringify(""));
  const dealer = JSON.parse(sessionStorage.getItem("dealer") || JSON.stringify(""));

  return (
    <>
      {((row.status === "Quote" || row.status === "Archived") || dealer.startsWith("Golden State")) && (
        <TableCell padding="checkbox">
          {(numSelected && numSelected > 0) || hoverId === row._id ? (
            <StyledCheckbox
              color="primary"
              onClick={(event: React.MouseEvent<any>) =>
                handleCheck(event, row as QuoteObj)
              }
              checked={isItemSelected}
            />
          ) : (
            <div style={{ width: 16, height: 16 }} />
          )}
        </TableCell>
      )}

      <TableCell
        onClick={() => handleViewClick && handleViewClick(row as QuoteObj)}
        padding="checkbox"
      >
        <StyledViewQuote variant="caption">View</StyledViewQuote>
      </TableCell>

      {tab === "Quotes" ? (
        <>
          <TableCell align="center" scope="row" padding="none">
            {new Date(String(row.updatedAt)).toLocaleDateString("en-US")}
          </TableCell>
          <TableCell align="center" scope="row" padding="none">
            {row.updatedAt
              ? new Date(row.updatedAt).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "N/A"}
          </TableCell>
        </>
      ) : (
        <TableCell align="center" scope="row" padding="none">
          {row.dateOrdered
            ? new Date(row.dateOrdered).toLocaleDateString("en-US")
            : "N/A"}
        </TableCell>
      )}

      <StyledTableCell align="center">
        {row.customerName && row.customerName.trim()
          ? row.customerName
          : "None"}
      </StyledTableCell>
      <TableCell align="center">{row.quoteNumber}</TableCell>

      {(role === "Company Manager" || role === "Manager II") && (
        <TableCell align="center">{row.dealer}</TableCell>
      )}

      {role && role.includes("Manager") && (
        <TableCell align="center">{row.salesperson}</TableCell>
      )}

      <TableCell align="center">{row.jobName || "None"}</TableCell>

      <TableCell align="center">{row.poNumber || "None"}</TableCell>

      {role && role.includes("Manager") && (
        <TableCell align="center">
          {row.grandTotal && !row.adminCharge
            ? row.grandTotal
            : row.grandTotal &&
              typeof row.userId === "object" &&
              dealerTax
            ? row.grandTotal
            : row.grandTotal && row.adminCharge
              ? calcWithAdminCharge(row.grandTotal, row.adminCharge)
              : "N/A"}
        </TableCell>
      )}

      <TableCell align="center">{row.totalUnits || "None"}</TableCell>

      <StatusTooltip role="Dealer" row={row as QuoteObj} tab={tab} />
    </>
  );
};

export default DealerCells;
